const AUTH_PATHS = ['/login', '/register', '/auth/google', '/verify-email'];

/**
 * Where to send a user after signing in: back to the page they were trying
 * to reach (stored in router state by ProtectedRoute / Navbar), otherwise
 * their dashboard.
 */
export const getPostAuthPath = (locationState, user) => {
  const from = locationState?.from;
  if (from?.pathname && !AUTH_PATHS.includes(from.pathname)) {
    return `${from.pathname}${from.search || ''}${from.hash || ''}`;
  }
  return user?.is_admin ? '/admin' : '/dashboard';
};

const AFTER_VERIFY_KEY = 'azamein.afterVerifyPath';

/**
 * A new account signs in from the link in its confirmation email, which loses
 * the router state. Keep the page they were heading to in this browser so the
 * link can take them back there.
 */
export const rememberAfterVerifyPath = (locationState) => {
  try {
    const path = getPostAuthPath(locationState, null);
    if (path === '/dashboard') localStorage.removeItem(AFTER_VERIFY_KEY);
    else localStorage.setItem(AFTER_VERIFY_KEY, path);
  } catch {
    // Storage blocked (private mode): they land on the dashboard instead.
  }
};

export const takeAfterVerifyPath = (user) => {
  let saved = null;
  try {
    saved = localStorage.getItem(AFTER_VERIFY_KEY);
    localStorage.removeItem(AFTER_VERIFY_KEY);
  } catch {
    // Storage blocked: fall back to the default below.
  }
  // Only same-site paths, never "//host" or a full URL.
  if (saved && saved.startsWith('/') && !saved.startsWith('//')) return saved;
  return getPostAuthPath(null, user);
};
